<template>
  <MainContent>
    <div class="container-fluid" :key="activeCompany._id" v-if="activeCompany">
      <div v-if="activeCompany.settings.competitionEnabled">
        <CompetitionViews />
      </div>
      <CompetitionOffState v-else />
    </div>
  </MainContent>
</template>

<script>
import { trackEvent } from '@/lib/analytics'
import MainContent from '@/components/MainContent/MainContent'
import CompetitionViews from '@/components/Modules/Competition/CompetitionViews.vue'
import CompetitionOffState from '@/components/Modules/Competition/CompetitionOffState.vue'
import { createNamespacedHelpers } from 'vuex'

const CompanyModule = createNamespacedHelpers('company')

export default {
  name: 'CompetitionPage',
  components: {
    MainContent,
    CompetitionViews,
    CompetitionOffState
  },
  computed: {
    ...CompanyModule.mapGetters(['activeCompany'])
  },
  async mounted() {
    trackEvent(this.$intercom, 'Competition')
  }
}
</script>
